import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "me-auto" };
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        ref: "toastEl",
        class: "toast",
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        onMouseup: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.handleMouseUp && _ctx.handleMouseUp(...args)))
    }, [
        _createElementVNode("div", {
            class: _normalizeClass(['toast-header', `bg-${_ctx.toast.variant}`, _ctx.headerTextColorClass])
        }, [
            _createElementVNode("strong", _hoisted_1, _toDisplayString(_ctx.toast.title), 1),
            _createElementVNode("small", null, _toDisplayString(_ctx.toast.timestamp), 1),
            (_ctx.toast.showCloseBtn !== false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["btn-close", _ctx.closeButtonClass]),
                    "data-bs-dismiss": "toast",
                    "aria-label": "Close"
                }, null, 2))
                : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
            class: "toast-body",
            innerHTML: _ctx.toast.message
        }, null, 8, _hoisted_2)
    ], 544));
}
